import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UrlValidationService {

private approvedDomainList = ['mapfreinsurance.com', 's3.amazonaws.com', 'paymentus.com', 'aaa.com', 'paybill.com', 'prep8.i-doxs.net', 'secure6.i-doxs.net' ];



  isApprovedRedirectUrl(urlString: string): boolean {
    try {
        const url = new URL(urlString);
        const protocol = url.protocol.toLowerCase();
        const hostname = url.hostname.toLowerCase();
        const approvedDomains = this.approvedDomainList.map(domain => domain.toLowerCase());
    
        // Handle blob URLs separately
        if (protocol === 'blob:') {
          const origin = new URL(url.origin).hostname.toLowerCase();
          const isBlobDomainApproved = approvedDomains.some(domain =>
            origin === domain || origin.endsWith('.' + domain)
          );
          return isBlobDomainApproved && urlString.length <= 2048;
        }
    
        // Regular HTTPS URL validation
        const isDomainApproved = approvedDomains.some(domain =>
          hostname === domain || hostname.endsWith('.' + domain)
        );
    
        const isHttps = protocol === 'https:';
        const isLengthValid = urlString.length <= 2048;
    
        return isHttps && isDomainApproved && isLengthValid;
      } catch {
        return false;
      }
  }
  
}